import Vue from 'vue';

// define the possible mutations that can be applied to our state
const mutations = {
    // ------------------------ ERRORS ------------------------
    ADD_ERROR: function(state, data) {
    	if(this.getters.devmode) console.debug('ADD_ERROR', data);
        var errors = state.errors.slice(0);
        errors.push(data);
        state.errors = errors;
    },
    REMOVE_ERROR: function(state, id) {
    	if(this.getters.devmode) console.debug('REMOVE_ERROR', id);
        state.errors = state.errors.filter(err => {
            return err.id !== id;
        });
    },
    UNSET_ERRORS: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_ERRORS');
        state.errors = [];
    },

    // ------------------------ NOTICE ------------------------
    ADD_NOTICE: function(state, data) {
    	if(this.getters.devmode) console.debug('ADD_NOTICE', data);
    	var notices = state.notices;
        if(!data.id) data.id = Math.random().toString(16); // @ToDo ggf hier was besseres
        if(!data.removeAble) data.removeAble = true;
        notices.push(data);
        state.notices = notices;
    },

    REMOVE_NOTICE: function(state, id) {
    	if(this.getters.devmode) console.debug('REMOVE_NOTICE', id);
        state.notices = state.notices.filter(note => {
            return note.id !== id;
        });
    },
    UNSET_NOTICE: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_NOTICE');
        state.notices = [];
    },

    SET_DEBUG(state){
    	if(this.getters.devmode) console.debug('SET_DEBUG');
    	state.debug = true;
    },
    UNSET_DEBUG(state){
    	if(this.getters.devmode) console.debug('UNSET_DEBUG');
    	state.debug = false;
    },



    // ------------------------ SAVEING ------------------------
    START_SAVEING: function(state) {
    	if(this.getters.devmode) console.debug('START_SAVEING');
        state.saveing = true;
    },
    END_SAVEING: function(state) {
    	if(this.getters.devmode) console.debug('END_SAVEING');
      	state.saveing = false;
    },
    // ------------------------ EDITING ------------------------
    START_EDITING: function(state) {
    	if(this.getters.devmode) console.debug('START_EDITING');
        state.editing = true;
    },
    END_EDITING: function(state) {
    	if(this.getters.devmode) console.debug('END_EDITING');
      	state.editing = false;
    },
    // ------------------------ CHANGED ------------------------
    HAS_CHANGED: function(state) {
    	if(this.getters.devmode) console.debug('HAS_CHANGED');
        state.changed = true;
    },
    RESET_CHANGED: function(state) {
    	if(this.getters.devmode) console.debug('RESET_CHANGED');
      	state.changed = false;
    },

	// ------------------------ LOADING ------------------------
    START_LOADING: function(state, name) {
    	if(!name) console.error('START_LOADING requires a name');
    	if(this.getters.devmode) console.debug('START_LOADING', name);
    	Vue.set(state.loading, name, true);
    },
    END_LOADING: function(state, name) {
    	if(!name) console.error('END_LOADING requires a name');
    	if(this.getters.devmode) console.debug('END_LOADING', name);
    	Vue.set(state.loading, name, false);
    },



    // ------------------------ NAVIGATION ------------------------
    // $store.getters.slimnavigation
    TOGGLE_SLIMNAVIGATION: function(state){
    	if(this.getters.devmode) console.debug('TOGGLE_SLIMNAVIGATION');
    	state.slimnavigation = !state.slimnavigation;
    },
    ENABLE_SLIMNAVIGATION: function(state){
    	if(this.getters.devmode) console.debug('ENABLE_SLIMNAVIGATION');
    	state.slimnavigation = true;
    },
    DISABLE_SLIMNAVIGATION: function(state){
    	if(this.getters.devmode) console.debug('DISABLE_SLIMNAVIGATION');
    	state.slimnavigation = false;
    },

    // ------------------------ CHANNEL ------------------------
    SET_CHANNEL: function(state, data) {
    	if(this.getters.devmode) console.debug('SET_CHANNEL', data);

    	if(typeof data === 'object') data.time = new Date().getTime();

        state.channel = data;
    },
    UNSET_CHANNEL: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_CHANNEL');
        state.channel = false;
    },
    // ------------------------ CHANNELS ------------------------
    SET_CHANNELS: function(state, data) {
    	if(this.getters.devmode) console.debug('SET_CHANNELS', data);
        state.channels = data;
    },
    UNSET_CHANNELS: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_CHANNELS');
        state.channels = false;
    },





    // ------------------------ USER ------------------------
    SET_USER: function(state, data) {
    	if(this.getters.devmode) console.debug('SET_USER', data);
        state.user = data;
    },
    UNSET_USER: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_USER');
        state.user = {};
    },
    SET_EDITUSER: function(state, data) {
    	if(this.getters.devmode) console.debug('SET_EDITUSER', data);

    	if(data.id){
	        this.dispatch('socket/SEND_PACKAGE', {
				name: 'start edit user',
				payload: data.id,
				time: new Date().getTime()
			});
        }

        state.edituser = data;
    },
    UNSET_EDITUSER: function(state) {
    	if(this.getters.devmode) console.debug('UNSET_EDITUSER');

        if(state.edituser.id){
	        this.dispatch('socket/SEND_PACKAGE', {
				name: 'end edit user',
				payload: state.edituser.id,
				time: new Date().getTime()
			});
        }

        state.edituser = false;
    },
    RESET_EDITUSER: function(state) {
    	if(this.getters.devmode) console.debug('RESET_EDITUSER');

    	if(state.edituser.id){
	        this.dispatch('socket/SEND_PACKAGE', {
				name: 'end edit user',
				payload: state.edituser.id,
				time: new Date().getTime()
			});
        }

        state.edituser = false;
    },


    TOGGLE_DEVMODE: function(state) {
    	if(this.getters.devmode) console.debug('TOGGLE_DEVMODE');
        state.devmode = !state.devmode;
    },
    SET_DEVMODE: function(state, data) {
    	if(this.getters.devmode) console.debug('SET_DEVMODE', data);
        state.devmode = data;
    },
    RESET_DEVMODE: function(state) {
    	if(this.getters.devmode) console.debug('RESET_DEVMODE');
        state.devmode = false;
    },

    MOUSE_MOVE: function(state, event) {
        state.mouseposition.x = event.pageX;
		state.mouseposition.y = event.pageY;
    },

    LOGOUT: function(state){
    	if(this.getters.devmode) console.debug('LOGOUT');
    	const actions = [
    		'UNSET_CHANNEL',
    		'UNSET_CHANNELS',
    		'DISABLE_SLIMNAVIGATION',
    		'UNSET_NOTICE',
    		'END_SAVEING',
    		'END_EDITING',
    		'RESET_CHANGED',
    		'UNSET_PRESENTATION',
    		'RESET_PRESENTATIONID',
    		'UNSET_USER',
    		'RESET_EDITUSER',
    		'UNSET_CHARTTEMPLATES'
    	];

    	actions.forEach(action => {
    		try {
				this.commit(action);
    		} catch(e) {
    			console.error(e)
    		}
		});

		this.commit('END_LOADING', 'LOGOUT');
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js